"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.button.login': 'Zaloguj się teraz',
    'activate.button.back_login': 'Powróć do logowania',
    'activate.button.register_again': 'Zarejestruj się ponownie',
};
